module.exports = __webpack_public_path__ + "img/MBT_C.cb912088.jpg";